
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ph",
      function () {
        return require("private-next-pages/ph/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ph"])
      });
    }
  